export default [

    {
        path: '',
        name: 'ppc',
        component: () => import('@/aplicacao/modulos/ppc/PPC'),
        meta: { autenticacao: true },
    },

]
